// src/components/Auth/ForgotPassword.jsx

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus('');
    setError('');
    setLoading(true);

    try {
      const response = await axios.post('/auth/forgot-password', { email });
      setStatus(response.data.message || 'Check your email for reset instructions.');
    } catch (err) {
      setError(err.response?.data?.message || 'Unable to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-layout">
      <section className="auth-hero">
        <div className="auth-hero-content">
          <div className="badge badge-muted" style={{ color: 'white' }}>
            Security
          </div>
          <h1 style={{ fontSize: '3rem', lineHeight: 1.1, margin: '1.5rem 0' }}>
            Reset access to your Control Center
          </h1>
          <p style={{ fontSize: '1.05rem', color: 'rgba(255,255,255,0.85)' }}>
            Enter your work email and we will send you a secure link to choose a new password.
          </p>
        </div>
      </section>

      <section className="auth-panel">
        <div className="auth-card">
          <header style={{ marginBottom: '1rem' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '0.3rem' }}>Forgot password</h2>
            <p className="text-muted">
              We will email you a link to reset your password. The link expires after a short time.
            </p>
          </header>

          {status && <div className="success-banner">{status}</div>}
          {error && <div className="error-banner">{error}</div>}

          <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '1rem' }}>
            <div className="field">
              <label htmlFor="email">Work email</label>
              <input
                id="email"
                name="email"
                type="email"
                className="input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
                required
              />
            </div>

            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Sending...' : 'Send reset link'}
            </button>
          </form>

          <p className="text-muted" style={{ marginTop: '1.5rem', fontSize: '0.9rem' }}>
            Remembered? <Link to="/login" style={{ fontWeight: 600 }}>Return to sign in</Link>
          </p>
        </div>
      </section>
    </div>
  );
};

export default ForgotPassword;
